import React, { useState } from 'react';

// How NinjaEval authenticates to a customer's endpoint. Values are write-only: once saved, only the last 4 characters show.
export const authFromSaved = (saved) => ({ kind: !saved?.length || saved[0].name === 'Authorization' ? 'bearer' : 'header', key: '', name: '', value: '' });

// The headers to save: null = keep what's saved, {} = remove saved headers.
export function authHeaders(a) {
  if (a.kind === 'none') return {};
  if (a.kind === 'bearer') {
    const key = (a.key || '').trim().replace(/^bearer\s+/i, '');   // people often paste "Bearer …" too
    return key ? { Authorization: `Bearer ${key}` } : null;
  }
  const name = (a.name || '').trim(), value = (a.value || '').trim();
  return name && value ? { [name]: value } : null;
}

export function SavedAuth({ saved }) {
  if (!saved?.length) return null;
  return <div className="sm" style={{ marginBottom: 6 }}>{saved.map((h) => <div key={h.name}>🔒 {h.name === 'Authorization' ? 'API key' : <span className="mono">{h.name}</span>} saved
    {h.last4 && <> (ends in <b className="mono">…{h.last4}</b>)</>}</div>)}
    <span className="xs fnt">Check those last 4 characters match your real key. Paste a new one below to replace it.</span></div>;
}

export function AuthInput({ value, onChange, saved, keyOnly, hint, keysUrl, keysLabel }) {
  const [show, setShow] = useState(false);
  const set = (k, v) => onChange({ ...value, [k]: v });
  const KINDS = [['bearer', 'API key'], ['header', 'Custom header'], ['none', 'No auth']];
  return (
    <div className="ef-field">
      <label>{keyOnly ? 'API key' : 'Authentication'}{keysUrl && <> <a className="fnt" href={keysUrl} target="_blank" rel="noreferrer">· get a key from {keysLabel} ↗</a></>}</label>
      {!keyOnly && <div style={{ display: 'flex', gap: 6, marginBottom: 8, flexWrap: 'wrap' }}>
        {KINDS.map(([k, l]) => <button key={k} type="button" className={'ef-btn sm' + (value.kind === k ? '' : ' ghost')} onClick={() => set('kind', k)}>{l}</button>)}</div>}
      {value.kind !== 'none' && <SavedAuth saved={saved} />}
      {value.kind === 'bearer' && <>
        <div style={{ display: 'flex', gap: 6 }}>
          <input className="ef-inp mono" type={show ? 'text' : 'password'} autoComplete="off" value={value.key} onChange={(e) => set('key', e.target.value)}
            placeholder={saved?.length ? 'Paste a new key to replace the saved one' : `Paste your API key${hint ? `, e.g. ${hint}` : ''}`} />
          <button type="button" className="ef-btn sm ghost" onClick={() => setShow(!show)}>{show ? 'Hide' : 'Show'}</button></div>
        <div className="xs fnt" style={{ marginTop: 4 }}>Paste just the key. It's encrypted and only ever sent to {keyOnly ? 'this provider' : 'your endpoint URL'} (as <span className="mono">Authorization: Bearer …</span>).</div></>}
      {value.kind === 'header' && <>
        <div style={{ display: 'flex', gap: 6 }}>
          <input className="ef-inp mono" style={{ width: 170 }} value={value.name} onChange={(e) => set('name', e.target.value)} placeholder="Header name, e.g. x-api-key" />
          <input className="ef-inp mono" type={show ? 'text' : 'password'} autoComplete="off" value={value.value} onChange={(e) => set('value', e.target.value)} placeholder="Value" />
          <button type="button" className="ef-btn sm ghost" onClick={() => setShow(!show)}>{show ? 'Hide' : 'Show'}</button></div>
        <div className="xs fnt" style={{ marginTop: 4 }}>For APIs that want the key in their own header. Encrypted at rest, sent only to your endpoint URL.</div></>}
      {value.kind === 'none' && <div className="xs fnt">Nothing is sent{saved?.length ? '; the saved key is removed when you send or save' : ''}. Private Cloud Run URLs get a Google identity token automatically.</div>}
    </div>
  );
}
